import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';
import useErrorStore, { setErrorActionSelector } from 'Core/stores/error';
import { useQuery } from 'react-query';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import { get } from 'Core/utils/api';
import { errorPath } from 'Core/routes';

export function useGetTokenInfo() {
  const { t } = useTranslation();
  const setError = useErrorStore(setErrorActionSelector);
  const navigate = useNavigate();

  return useQuery(cacheKeys.tokenInfo, () => get('/api/pay-token'), {
    onError(e) {
      if (e) {
        setError(t('status.error.getGetTokenInfoFailed') + e.message);
        navigate({ to: errorPath, search: true });
      }
    },
  });
}
